// extracted by mini-css-extract-plugin
module.exports = {"PageStartupBlock__button":"PageStartupBlock_PageStartupBlock__button__aiG9v","PageStartupBlock__icon":"PageStartupBlock_PageStartupBlock__icon__2g3Wx"};